export default {
      id: "email-usage",
      viewBox: "0 0 60 60",
      url: __webpack_public_path__ + "img/iconaf3563da19c86b00e5da1e83cc285294.svg#email",
      toString: function () {
        return this.url;
      }
    }